"use client";

import { ArrowUpRight, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Location() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const coordinates = [{
    label: "UBICACIÓN",
    value: "Las Rozas, Madrid"
  }, {
    label: "ZONA",
    value: "C/ Cruces 7"
  }, {
    label: "CONTACTO",
    value: "+34 626 475 620"
  }];
  const mapUrl = "https://www.google.com/maps/search/?api=1&query=C/Cruces+7+Las+Rozas+Madrid";
  return <section data-section-id="2002" id="locationmap" className="relative bg-[#F5F0EA] text-[#1C2F5E] py-24 md:py-32 border-t border-[#C9A8A8]/30 overflow-hidden">
      <div ref={ref} className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-[4.5rem]">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {}
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-28 relative">
              {}

              {}
              <div className={`relative transition-all duration-[640ms] ease-[cubic-bezier(0.22,1,0.36,1)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
                <div className="flex items-center gap-3 mb-8">
                  
                  
                </div>

                {}
                <h2 className="font-default font-normal leading-[1.02] tracking-tight text-[#1C2F5E] mb-12" style={{
                fontSize: "clamp(2.25rem, 4.2vw, 4.25rem)"
              }}>Visita<br /><span className="italic font-light text-[#C9A96E] relative inline-block" data-ast-id="f:/src/pages/Contact/sections/Location.tsx|sig:hqp57m" data-ast-start="1997" data-ast-end="2469">nuestra clínica<span className="absolute left-0 -bottom-1 h-px bg-[#C9A96E] transition-[width] duration-[480ms] ease-[cubic-bezier(0.22,1,0.36,1)] delay-200 w-full" data-ast-id="f:/src/pages/Contact/sections/Location.tsx|sig:xzke0c" data-ast-start="2195" data-ast-end="2462"></span></span><br /></h2>
              </div>

              {}
              <ul className="space-y-0 mb-10">
                {coordinates.map((coord, i) => <li data-index={i} key={i} className={`relative py-5 transition-all duration-[640ms] ease-[cubic-bezier(0.22,1,0.36,1)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
                transitionDelay: `${160 + i * 80}ms`
              }}>
                    <div className="flex items-baseline justify-between gap-4">
                      <span className="font-default text-[0.6875rem] font-medium tracking-[0.18em] uppercase text-[#C9A8A8]">
                        {coord.label}
                      </span>
                      <span className="font-default text-sm text-[#1C2F5E] tracking-wide text-right">
                        {coord.value}
                      </span>
                    </div>
                    {}
                    <div className="absolute bottom-0 left-0 right-0 h-px bg-[#C9A8A8]/30 flex items-center justify-end">
                      <span className="block w-1.5 h-1.5 rounded-lg bg-[#C9A96E] translate-x-1/2" />
                    </div>
                  </li>)}
              </ul>

              {}
              <Link to={mapUrl} newTab className="group inline-flex items-center gap-2 font-default text-[0.8125rem] font-medium tracking-[0.18em] uppercase text-[#1C2F5E]">
                <span className="relative">
                  Ver en Google Maps
                  <span className="absolute left-0 -bottom-1 h-px bg-current w-3 group-hover:w-full transition-[width] duration-[280ms] ease-out" />
                  <span className="absolute -bottom-1 right-0 w-1 h-1 rounded-lg bg-[#C9A96E] opacity-0 group-hover:opacity-100 transition-opacity duration-[280ms]" />
                </span>
                <ArrowUpRight className="size-4 transition-transform duration-[280ms] group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </Link>
            </div>
          </div>

          {}
          <div className="lg:col-span-8">
            <div className={`relative transition-all duration-[640ms] ease-[cubic-bezier(0.22,1,0.36,1)] delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
              <div className="relative aspect-[4/5] lg:aspect-[16/13] w-full overflow-hidden bg-[#EAE4DD] border border-[#C9A8A8]/40">
                {}
                <iframe title="Ubicación MS Instituto Capilar" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3034.644444444444!2d-3.875555555555555!3d40.49111111111111!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd41833333333333%3A0x3333333333333333!2sC.%20Cruces%2C%207%2C%2028231%20Las%20Rozas%20de%20Madrid%2C%20Madrid!5e0!3m2!1ses!2ses!4v1710000000000!5m2!1ses!2ses" className="w-full h-full" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />

                {}
                <span aria-hidden="true" className="absolute top-3 left-3 w-2 h-2 border-t border-l border-[#C9A8A8]" />
                <span aria-hidden="true" className="absolute top-3 right-3 w-2 h-2 border-t border-r border-[#C9A8A8]" />
                <span aria-hidden="true" className="absolute bottom-3 left-3 w-2 h-2 border-b border-l border-[#C9A8A8]" />
                <span aria-hidden="true" className="absolute bottom-3 right-3 w-2 h-2 border-b border-r border-[#C9A96E]" />

                {}
                <div className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                  <div className="relative flex items-center">
                    {}
                    <span className="relative flex items-center justify-center">
                      <span className="absolute w-3 h-3 rounded-lg bg-[#C9A96E]/40" style={{
                      animation: "rootsPulse 1.6s ease-in-out infinite"
                    }} />
                      <span className="relative block w-3 h-3 rounded-lg bg-[#C9A96E]" />
                    </span>
                    {}
                    <span className="block w-16 h-px bg-[#C9A8A8]/50 relative">
                      <span className="absolute right-0 top-1/2 -translate-y-1/2 w-1 h-1 rounded-lg bg-[#C9A96E]" />
                    </span>
                    {}
                    <span className="ml-2 font-default text-[0.6875rem] font-medium tracking-[0.18em] uppercase text-[#1C2F5E] bg-[#F5F0EA]/85 backdrop-blur-sm px-2 py-1 border border-[#C9A8A8]/40">
                      MS / LAS ROZAS
                    </span>
                  </div>
                </div>
              </div>

              {}
              <div className="mt-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div className="flex items-start gap-3">
                  <MapPin className="size-4 text-[#C9A96E] mt-0.5 shrink-0" />
                  <div>
                    <p className="font-default text-[0.6875rem] font-medium tracking-[0.18em] uppercase text-[#C9A8A8] mb-1">
                      Dirección
                    </p>
                    <p className="text-sm text-[#1C2F5E] leading-relaxed">
                      C/ Cruces 7, Las Rozas, Madrid
                    </p>
                  </div>
                </div>

                <Button asChild className="bg-[#1C2F5E] hover:bg-[#1C2F5E]/90 text-[#F5F0EA] rounded-lg px-8 h-12 font-medium tracking-[0.04em] uppercase text-[13px] hover:-translate-y-0.5 hover:shadow-lg transition-all duration-220 ease-out">
                  <Link to={mapUrl} newTab>
                    Cómo llegar
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes rootsPulse {
          0%, 100% { transform: scale(1); opacity: 0.6; }
          50% { transform: scale(2.4); opacity: 0; }
        }
      `}</style>
    </section>;
}